import { render, staticRenderFns } from "./ResourceChatBubble.vue?vue&type=template&id=e93a24ae"
import script from "./ResourceChatBubble.vue?vue&type=script&lang=js"
export * from "./ResourceChatBubble.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports